import bowser from "bowser";
import ChatActions from "../../actions/ChatActions";
import alt from "../../alt/ChatAlt";

import BrowserNotificationPermission from "../../constants/BrowserNotificationPermission";

class BrowserNotificationStore {
    constructor() {
        this.bindActions(ChatActions);
        this.state = { permission: BrowserNotificationPermission.default };
    }

    onGrantBrowserNotifications() {
        this.setState({ permission: BrowserNotificationPermission.granted });
    }

    onDenyBrowserNotifications() {
        this.setState({ permission: BrowserNotificationPermission.denied });
    }

    static shouldDisplayPrompt() {
        return (
            "Notification" in window &&
            "serviceWorker" in navigator &&
            bowser.chrome &&
            this.getState().permission === BrowserNotificationPermission.default
        );
    }
}

export default alt.createStore(BrowserNotificationStore, "BrowserNotificationStore");
